// ----------------------------------------------------------------------- imports internos
import { useAuth } from "../auth/AuthContext";
import { MENSAJE_DE_BAJA } from "../auth/dominios";

/* Lo único que ve una cuenta del hub dada de baja (05/10).
 *
 * No es la protección: ésa la hacen la base —con la cuenta de baja ninguna
 * llave abre— y Supabase Auth, que no le acepta la clave ni le renueva el
 * token. Esto es para que la persona que llega con una sesión abierta no vea
 * un hub vacío y roto, que es lo que manda a pensar «se cayó el sistema»: ve
 * qué pasó y a quién preguntarle, y nada más.
 *
 * No dice quién la dio de baja ni por qué: eso está guardado para quien
 * administra, y es a esa persona a quien hay que ir a ver. */
const CuentaDeBaja = () => {
  const { logout } = useAuth();
  return (
    <div className="panel-aviso" role="alert" style={{ margin: "15vh auto", maxWidth: 480 }}>
      <h3>Cuenta dada de baja</h3>
      <p>{MENSAJE_DE_BAJA}</p>
      <button type="button" className="tk-chip activo" onClick={() => logout()}>
        Salir
      </button>
    </div>
  );
};

export default CuentaDeBaja;
